import { createAppWrapper } from "@/common.js";
import UnlockNew from "@/users/unlocks/New.vue";

document.addEventListener("DOMContentLoaded", () => {
  createAppWrapper(UnlockNew);
});
